import React, { useMemo } from 'react';
import { KeyMetricData } from 'src/types';
import { KeyMetricCard } from 'src/components/molecules/KeyMetricCard';
import { useMergeBenchmarkTimeseries } from 'src/hooks/useMergeBenchmarkTimeseries';
import { calculateTrendFromTimeSeries } from 'src/utils/calculateTrendFromTimeSeries';
import { useDADataContext } from '../../../contexts/DADataContext';
import { calculateTotalCPA } from '../../../utils/conversionsAggregator';
// eslint-disable-next-line no-restricted-imports
import { Icon as ChakraIcon } from '@chakra-ui/react';
import { Tag } from 'lucide-react';

export const CPA: React.FC = () => {
  const { conversions, benchmarkConversions } = useDADataContext();
  const { getMergedTimeSeries } = useMergeBenchmarkTimeseries();

  const keyMetricData: KeyMetricData = useMemo(() => {
    let spendSum = 0;
    let conversionsSum = 0;

    const data = getMergedTimeSeries(
      conversions.data,
      benchmarkConversions.data,
      (v) => ({ value: v.measurements.cpa }),
      (v) => ({ benchmark: v.measurements.cpa }),
      false,
      'day',
    );

    conversions.data.forEach((x) => {
      spendSum += x.measurements.spend;
      conversionsSum += x.measurements.modelledConversions;
    });

    return {
      name: 'CPA',
      data,
      isEuro: false,
      summaryValue: calculateTotalCPA(spendSum, conversionsSum),
      isLoading: conversions.isLoading,
      isError: conversions.isError,
    };
  }, [conversions, getMergedTimeSeries, benchmarkConversions.data]);

  const { trend, trendValue } = useMemo(() => {
    return calculateTrendFromTimeSeries(keyMetricData?.data ?? []);
  }, [keyMetricData]);

  return (
    <KeyMetricCard
      title="CPA"
      trend={trend}
      trendValue={trendValue}
      value={keyMetricData.summaryValue}
      isLoading={keyMetricData.isLoading}
      isError={keyMetricData.isError}
      icon={<ChakraIcon as={Tag} boxSize={5} color="gray.500" />}
    />
  );
};
